import { useQuery } from "@tanstack/react-query";
import { internalCustomerDictionaryService } from "../../services/dictionaries";

export const useInternalCustomersDictionary = () => {
    return useQuery({
        queryKey: ["internal-customers", "dictionary"],
        queryFn: (): Promise<string[]> =>
            internalCustomerDictionaryService.getCustomerNames(),
        staleTime: 1000 * 60 * 15, // 15 minutes
        gcTime: 1000 * 60 * 30, // 30 minutes
    });
};
